import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetNewTokenFxn } from "../Services/Actions/LoginSignupActions";
import { store } from "../Services";
import Loader from "../Component/Loader";

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const rememberMeToken = localStorage.getItem("remember_me_token");

    const handleLoader = (loading = false) => {
      setLoading(loading);
    };

    React.useEffect(() => {
      if (rememberMeToken) {
        GetNewTokenFxn(
          { remember_me_token: rememberMeToken },
          store.dispatch,
          handleLoader
        );
      }
    }, [rememberMeToken]);

    if (loading) {
      return <Loader showLoader={true} />;
    }
    return <Component navigate={navigate} {...props} />;
  };

  return Wrapper;
};
